// extracted by mini-css-extract-plugin
module.exports = {"appButton":"styles_appButton__6g3EI","primary":"styles_primary__mxKwn","secondary":"styles_secondary__Hcibv","tertiary":"styles_tertiary__h_WbK"};